import {
    APP_VERSIONS_UPLOAD_ENDPOINT,
    APP_VERSIONS_ENDPOINT,
    APP_VERSION_BY_ID_ENDPOINT,
    APP_VERSION_APPROVE_ENDPOINT,
    APP_VERSION_REJECT_ENDPOINT,
    APP_VERSION_ACTIVATE_ENDPOINT,
    APP_VERSION_DELETE_ENDPOINT,
    APP_VERSION_STATISTICS_ENDPOINT,
    APP_VERSION_ACTIVE_ENDPOINT,
    APP_VERSION_INFO_ENDPOINT
} from "../api-services/ApiEndpoints";

const getAuthHeaders = () => {
    const token = localStorage.getItem('token');
    return {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
    };
};

const getAuthHeadersMultipart = () => {
    const token = localStorage.getItem('token');
    return {
        'Authorization': `Bearer ${token}`
    };
};

export const uploadAppVersion = async (formData) => {
    const url = `${process.env.REACT_APP_API_URL}${APP_VERSIONS_UPLOAD_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'POST',
            headers: getAuthHeadersMultipart(),
            body: formData
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to upload version: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Upload version error:', error);
        throw error;
    }
};

export const getAllVersions = async (params = {}) => {
    const queryParams = new URLSearchParams();
    if (params.status) queryParams.append('status', params.status);
    if (params.isActive !== undefined) queryParams.append('isActive', params.isActive);
    if (params.limit) queryParams.append('limit', params.limit);
    
    const queryString = queryParams.toString();
    const url = `${process.env.REACT_APP_API_URL}${APP_VERSIONS_ENDPOINT}${queryString ? '?' + queryString : ''}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch versions: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get versions error:', error);
        throw error;
    }
};

export const getVersionById = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${APP_VERSION_BY_ID_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch version: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get version error:', error);
        throw error;
    }
};

export const approveVersion = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${APP_VERSION_APPROVE_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to approve version: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Approve version error:', error);
        throw error;
    }
};

export const rejectVersion = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${APP_VERSION_REJECT_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to reject version: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Reject version error:', error);
        throw error;
    }
};

export const activateVersion = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${APP_VERSION_ACTIVATE_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to activate version: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Activate version error:', error);
        throw error;
    }
};

export const deleteVersion = async (id) => {
    const url = `${process.env.REACT_APP_API_URL}${APP_VERSION_DELETE_ENDPOINT.replace('{id}', id)}`;
    
    try {
        const response = await fetch(url, {
            method: 'DELETE',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to delete version: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Delete version error:', error);
        throw error;
    }
};

export const getVersionStatistics = async () => {
    const url = `${process.env.REACT_APP_API_URL}${APP_VERSION_STATISTICS_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: getAuthHeaders(),
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch statistics: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get statistics error:', error);
        throw error;
    }
};

export const getActiveVersion = async () => {
    const url = `${process.env.REACT_APP_API_URL}${APP_VERSION_ACTIVE_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch active version: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get active version error:', error);
        throw error;
    }
};

export const getActiveVersionInfo = async () => {
    const url = `${process.env.REACT_APP_API_URL}${APP_VERSION_INFO_ENDPOINT}`;
    
    try {
        const response = await fetch(url, {
            method: 'GET',
        });

        if (!response.ok) {
            const data = await response.json();
            throw new Error(data?.message || `Failed to fetch active version info: ${response.status}`);
        }

        return await response.json();
    } catch (error) {
        console.error('Get active version info error:', error);
        throw error;
    }
};
